<template>
  <TroodonNav>エラー</TroodonNav>
  <TroodonMain>
    <div class="c-error">
      <h2 class="c-error__title">予期しないエラーが発生しました。</h2>
      <p class="c-error__body">{{ baseMessage }}</p>
    </div>
  </TroodonMain>
</template>

<script setup lang="ts">
import '~/styles/troodon/_variables.scss'
import type { NuxtError } from '#app'
import TroodonMain from '~/components/troodon/troodon-main.vue'
import TroodonNav from '~/components/troodon/troodon-nav.vue'

const baseMessage = '大変申し訳ありませんが、しばらく経ってから再度お試しください。'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    required: true,
  },
})
</script>

<style scoped lang="scss">
.c-error {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px 0;
  text-align: center;
}

.c-error__title {
  margin: 0;
  color: var(--troodon-c-text-high);
  font-size: var(--troodon-f-size-lg);
  font-weight: 700;
  line-height: var(--troodon-lh-button);
}

.c-error__body {
  margin: 0;
  color: var(--troodon-c-text-low);
  font-size: var(--troodon-f-size-sm);
  font-weight: 400;
  line-height: var(--troodon-lh-input);
}
</style>
